module.exports = __webpack_public_path__ + "cc0e29766fe51c71fb8fda566951ef9b.svg";